import { useState } from 'react';
import axios from 'axios';

export const useInterests = (userId) => {
  const [userInterests, setUserInterests] = useState([]);
  const [userInterestInput, setUserInterestInput] = useState('');
  const [interestErrorMessage, setInterestErrorMessage] = useState('');
  const [topUserInterests, setTopUserInterests] = useState([]);
  const [latestPassageSubtopics, setLatestPassageSubtopics] = useState([]);

  const submitInterest = async () => {
    const interest = userInterestInput.trim();
    if (!interest) return;

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/add_interest`, {
        user_id: userId,
        interest
      });

      setUserInterests(response.data.interests);
      setUserInterestInput('');
      setInterestErrorMessage('');
    } catch (err) {
      console.error('Interest submission failed:', err);
      setInterestErrorMessage('Failed to submit interest.');
    }
  };

  const removeInterest = async (index) => {
    const interestToRemove = userInterests[index];
    const updated = [...userInterests];
    updated.splice(index, 1);
    setUserInterests(updated);

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/remove_interest`, {
        user_id: userId,
        interest: interestToRemove
      });
    } catch (err) {
      console.error('Interest removal failed:', err);
    }
  };

  return {
    // State
    userInterests, setUserInterests,
    userInterestInput, setUserInterestInput,
    interestErrorMessage, setInterestErrorMessage,
    topUserInterests, setTopUserInterests,
    latestPassageSubtopics, setLatestPassageSubtopics,
    
    // Methods
    submitInterest,
    removeInterest
  };
};
